import { cn } from '@/lib/utils';

export interface ButtonVariantsProps {
  variant?: 'default' | 'destructive' | 'outline' | 'secondary' | 'ghost' | 'link';
  size?: 'default' | 'sm' | 'lg' | 'icon';
}

export function buttonVariants({
  variant = 'default',
  size = 'default',
}: ButtonVariantsProps = {}) {
  return cn(
    'inline-flex items-center justify-center whitespace-nowrap rounded-xl text-sm font-medium ring-offset-white transition-all duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-coral-500 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50',
    {
      'bg-gradient-to-r from-coral-400 to-coral-600 text-white shadow-md hover:shadow-lg hover:-translate-y-0.5':
        variant === 'default',
      'bg-red-500 text-white hover:bg-red-600': variant === 'destructive',
      'border border-warm-200 bg-white text-warm-700 hover:bg-warm-50 hover:border-coral-300':
        variant === 'outline',
      'bg-warm-100 text-warm-700 hover:bg-warm-200': variant === 'secondary',
      'text-warm-600 hover:bg-warm-100 hover:text-warm-800': variant === 'ghost',
      'text-coral-600 underline-offset-4 hover:underline': variant === 'link',
    },
    {
      'h-10 px-4 py-2': size === 'default',
      'h-9 rounded-lg px-3 text-xs': size === 'sm',
      'h-11 rounded-xl px-8': size === 'lg',
      'h-10 w-10': size === 'icon',
    }
  );
}
